<app-notification></app-notification>
<router-outlet></router-outlet>
<app-loader></app-loader>